import { getProductData } from "../utilities";
import PriceDisplay from "./priceDisplay";
import globals from "../../common/globals";

const Price = {

  defaultCheaper: globals.priceDefaultCheaper || true,

  setPrice: async function(element, id, product) {
    const productData = await getProductData(id);
    if (!productData.success) return null

    const { variants } = productData.data
    if (!variants) return null

    product.addEventListener('vnda:sku-change', (event) => {
      const sku = event.detail.sku
      if (!sku) return

      Price.updatePrice(element, variants, sku)
    })

    Price.setPreSale(product, productData);

    return Price.updatePrice(element, variants)
  },

  setPreSale: function(product, obj) {
    const currentDate = new Date();
    product.classList.remove('-pre-sale');

    if(!obj.data.presale_end_at) return

    const presaleDate = new Date(obj.presale_end_at);

    if(presaleDate <= currentDate) return
    product.classList.add('-pre-sale');
  },

  setGroupShopPrice: function (productBlock, variant) {
    if (productBlock) {
      productBlock.setAttribute('data-price', variant.price);
      productBlock.setAttribute('data-sale-price', variant.sale_price);
      productBlock.setAttribute('data-available', variant.available);
      productBlock.dispatchEvent(new Event('vnda:group-shop-price-update'));
    }
  },

  updatePrice: function (element, variants, sku) {
    if (!element || !variants) return;

    const { defaultCheaper } = Price;
    let variant = false;

    if (sku && sku != '') {
      const findVariant = variants.filter((variant) => {
        if (variant.sku == sku) return variant;
      });

      if (findVariant.length > 0) variant = findVariant[0];
    }

    // Se não tiver um SKU explicito, busca a variante default
    if (!variant) {
      variant = variants[0];
      for (const v of variants) {
        if (!v.available || !v.stock > 0) continue;

        if (defaultCheaper && v.sale_price <= variant.sale_price) {
          variant = v;
        }
      }

      // Se a variante de menor preço não estiver disponível, busca a primeira variante disponível
      if (!variant.available) {
        variant = variants.find((v) => v.available) || variant;
      }
    }

    // Se por algum motivo não encontrou variante até aqui, default a primeira
    if (!variant) variant = variants[0];

    // Exibe os dados de preço conforme o tipo de produto
    const isMainProduct = element.closest('[data-section-product]');
    const groupShopProductBlock = element.closest('[data-prod-group-shop]');
 
    
    //No produto principal e no product block, exibe apenas "Produto Sob Consulta" quando indisponível
    if (isMainProduct) {
      PriceDisplay.productMain(element, variant);
    } else if(variant.available) {
      PriceDisplay.productBlock(element, variant);
    }

    if (!variant.available) {
      PriceDisplay.addUnavailable(element, isMainProduct);
    }

    if (groupShopProductBlock) {
      Price.setGroupShopPrice(groupShopProductBlock, variant);
    }

    element.setAttribute('data-sku-price', variant.sku);
    element.classList.add('-loaded');
  },

  init: function() {
    const products = document.querySelectorAll('[data-product-box]');
    if (products.length === 0) return

    const observer = new IntersectionObserver(async (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue

        const product = entry.target
        const id = product.getAttribute('data-product-box')
        const priceEl = product.querySelector('[data-update-price]')

        if (id == '' || id == null) {
          observer.unobserve(product)
          continue
        }

        if (!priceEl) {
          console.error(`Price: produto ${id} não possui elemento de preço.`)
          observer.unobserve(product)
          continue
        }

        Price.setPrice(priceEl, id, product)
        observer.unobserve(product)
      }
    })

    products.forEach(product => {
      observer.observe(product)
    })

    window.Price = Price
  }
}

export default Price
